export default "__VITE_ASSET__Bi$K4Nuq__"